<template lang="pug">
div
  stock-take-summary-desktop(:id="id" :savePage="savePage" :saveTab="saveTab" :saveSearch="saveSearch" :saveFilters="saveFilters" list-page="ClinicInventoryStockTake")

</template>

<script>
import StockTakeSummaryDesktop from '@/components/clinic/inventory/stocktake/StockTakeSummaryDesktop.vue'

export default {
  name: 'StockTakeSummary',
  components: { StockTakeSummaryDesktop },
  props: ['id', 'savePage', 'saveTab', 'saveSearch', 'saveFilters'],
  data () {
    return {}
  },
  computed: {},
  watch: {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>